import { CHAT_API } from "./config/api";
import { ChatHistoryResponse } from "./types";
import { apiGet } from "./utils";

// TODO: 现在的分页如果新增数据，指定 page 和 pageSize 是否合理？
// 因为我们需要通过时间倒序拉取历史记录
// 考虑数据库新增数据时，相同的分页数据会拿到不同的返回结果，不幂等。
// 假如初始化时共有 21 条数据，pageSize 为 10，当我执行 page 0 时，我拿到的，12 - 21。
// 此时新增 1 条数据，共 22 条数据，当我再次执行 page 0 时，我拿到的，13 - 22。
// 此时我拿 page 1 时，我拿到的，3 - 12。12 会产生重复？
export const fetchChatHistory = async ({
  page,
  pageSize,
}: {
  page: number;
  pageSize: number;
}) => {
  const response = await apiGet<{ data: ChatHistoryResponse }>(
    CHAT_API.history(),
    {
      page,
      page_size: pageSize,
    }
  );

  const { list, total, is_optional_login_pending } = response.data;

  return {
    list,
    total,
    is_optional_login_pending,
  };
};
